// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__1kAr9","icon":"style_icon__2twpm","title":"style_title__12poE","menuIcon":"style_menuIcon__EjAWg"};